<template>
<div>

    <b>RedChirp Widget</b>

    <p
        style="margin-top: 15px"
    >
        We are only gathering information at this point; wechat will <b>not</b> go live until you "flip the switch" inside of RedChirp.
    </p>

    <v-checkbox
        label="We plan to use the RedChirp widget to let customers text us from our website"
        v-model="setup_data.use_widget"
        v-on:change="doUpdate"
    />

    <div
        v-show="setup_data.use_widget"
    >
        <b>Website(s)</b>

         <p
            style="margin-top: 15px"
        >
            Please enter the domain name(s) that you would like to use the RedChirp widget on.  You can add multiple using the (+) button.
        </p>
        
        <div
            v-for="(item, index) in setup_data.urls"
            :key="index"
            v-on:input="update"
        >
            <v-text-field
                v-model="setup_data.urls[index]"
                append-icon="mdi-delete"
                v-on:click:append="onClickDeleteURL(index)"
            />

        </div>

        <m-icon-bar
            v-on:add="onClickAddURL()"
            style="margin-bottom: 15px"
        />

        

        <v-row>
            <v-col>
                <v-text-field
                    label="Web Developer First Name"
                    v-model="setup_data.web_dev_first_name"
                    autocomplete="off"
                    v-on:input="update"
                />
            </v-col>
            <v-col>
                <v-text-field
                    label="Web Developer Last Name"
                    v-model="setup_data.web_dev_last_name"
                    autocomplete="off"
                    v-on:input="update"
                />
            </v-col>
        </v-row>

        

        <v-text-field
            label="Web Developer Email Address"
            v-model="setup_data.web_dev_email_address"
            autocomplete="off"
            v-on:input="update"
        />

    </div>

    <v-switch
        label="This section is complete"
        v-model="setup_data.complete"
        v-on:change="doUpdate"
    />
   
</div>
</template>

<script>
const _ = require('lodash');

export default 
{
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },
    },

    data() {
        return {
            setup_data: {},
        }
    },

    mounted () {
        this.setup_data = _.cloneDeep(this.profile.website_organization_setup_data);

        if ( this.setup_data.urls.length == 0 )
        {
            this.setup_data.urls.push("");
        }
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/website-setup-data',
            
                'params' : this.setup_data,
            
                'on_success': (data) => {
                       
                        this.$emit('reload');
                        
                    },
            
                'on_error': 'Unable to save form data',
            });
        },

        onClickAddURL()
        {
            this.setup_data.urls.push("");
        },

        onClickDeleteURL(index)
        {
            this.setup_data.urls.splice(index,1);
            this.doUpdate();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>

